module.exports = __webpack_public_path__ + "static/media/arrow-right.ee8035ce.svg";